<script setup>
import AppIcon from "./AppIcon.vue";
</script>

<template>
  <footer class="ds-footer" role="contentinfo">
    <div class="ds-footer-inner">
      <div class="ds-footer-brand">
        <span class="ds-brand">
          <AppIcon name="logo" class="ds-brand-glyph" />
          <span class="ds-brand-text">
            <span class="ds-brand-word"><strong>Scion</strong>Carbon</span>
            <span class="ds-brand-sub">Project Center</span>
          </span>
        </span>
        <p>
          A registration and readiness system that helps Philippine LGUs, cooperatives and private owners turn
          climate-relevant assets into organized, evidence-backed, registry-ready project files.
        </p>
      </div>

      <div class="ds-footer-col">
        <h2 class="eyebrow">Contact</h2>
        <ul>
          <li><a href="mailto:sciontechnologyinc@gmail.com">sciontechnologyinc@gmail.com</a></li>
          <li><a href="mailto:info@sciontech.tech">info@sciontech.tech</a></li>
          <li>Partnership inquiries</li>
          <li>Project onboarding</li>
        </ul>
      </div>

      <div class="ds-footer-col">
        <h2 class="eyebrow">Explore</h2>
        <ul>
          <li><RouterLink to="/">Overview</RouterLink></li>
          <li><RouterLink to="/project-types">Project types</RouterLink></li>
          <li><RouterLink to="/feasibility">Feasibility</RouterLink></li>
          <li><RouterLink to="/investors">Investors &amp; buyers</RouterLink></li>
          <li><RouterLink to="/volunteers">Volunteers</RouterLink></li>
          <li><RouterLink to="/register">Register user</RouterLink></li>
          <li><RouterLink to="/register-project">Register a project</RouterLink></li>
        </ul>
      </div>
    </div>

    <p class="ds-footer-note">
      ScionCarbon Project Center is a registration and readiness system. It is
      <strong>not a carbon registry, certifier, validator, verifier or exchange.</strong>
      It prepares project files for those parties. &copy; Scion Technology Inc. &middot; Built and operated by
      ScionTechnology &middot; A Carbon Economy Center Philippines initiative.
    </p>
  </footer>
</template>
